export const STATS_BAR_STYLES = {
  root: "w-full",
  list: "grid grid-cols-2 gap-4 rounded-[16px] bg-white p-6 shadow-ticketon-card sm:grid-cols-4",
  item: "flex flex-col items-center justify-center gap-1 text-center",
  icon: "h-10 w-10 object-contain",
  value: "text-[22px] md:text-[28px] font-bold text-ticketon-dark-blue",
  label: "text-[12px] md:text-[13px] text-ticketon-gray-600",
} as const;
